import * as React from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import { Link } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import Button from '@mui/material/Button';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import PublicIcon from '@mui/icons-material/Public';
import PfIcon from '../assets/icons/PfIcon';
import SpotifyIcon from '../assets/icons/SpotifyIcon';
import AmazonMusicIcon from '../assets/icons/AmazonMusicIcon';
import YouTubeMusicIcon from '../assets/icons/YouTubeMusicIcon';
import AppleIcon from '@mui/icons-material/Apple';
import { Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

function CarloHome() {
    const releases = [
        {
            id: 'robot-fighting',
            title: 'Robot Fighting',
            subtitle: 'Album · 2012',
            coverUrl: 'https://pushforward.online/static/media/images/RobotFighting400.png',
            coverAlt: 'Lamer album cover',
            links: [
                {
                    label: 'Apple Music',
                    href: 'https://music.apple.com/us/album/robot-fighting/567884878',
                    icon: <AppleIcon />,
                },
                {
                    label: 'Spotify',
                    href: 'https://open.spotify.com/album/5prlsYcTT6zY0BpIBxUvZp',
                    icon: <SpotifyIcon />,
                },
                {
                    label: 'YouTube Music',
                    href: 'https://music.youtube.com/playlist?list=OLAK5uy_mEYJ_2PO2iDM-LewAB4muVl6MRrlkR4IE',
                    icon: <YouTubeMusicIcon />,
                },
                {
                    label: 'YouTube',
                    href: 'https://www.youtube.com/watch?v=xN-UFcNwd-o&list=OLAK5uy_kuf8UHl60LHuvgYcWoLkVoqDjoOI60Lp4',
                    icon: <YouTubeIcon />,
                },
            ],
        },
        {
            id: 'defiant-adventures-compliant-surrenders',
            title: 'Defiant Adventures Compliant Surrenders',
            subtitle: 'Album · 2008',
            coverUrl: 'https://pushforward.online/static/media/images/DACS400.png',
            coverAlt: 'Lamer album cover',
            links: [
                {
                    label: 'Apple Music',
                    href: 'https://music.apple.com/us/album/defiant-adventures-compliant-surrenders/6787295332',
                    icon: <AppleIcon />,
                },
                {
                    label: 'Spotify',
                    href: 'https://open.spotify.com/album/7x3CmPxpr2HDwsjQQk43F8',
                    icon: <SpotifyIcon />,
                },
                {
                    label: 'YouTube Music',
                    href: 'https://music.youtube.com/playlist?list=OLAK5uy_nVsHFq4jWNSlICpQWZc3BxZ8UJxLGQBnQ',
                    icon: <YouTubeMusicIcon />,
                },
                {
                    label: 'YouTube',
                    href: 'https://www.youtube.com/watch?v=-M1aCdTc7TA&list=OLAK5uy_k2r_WZV7dXiQrQOBAGAtCogBucb-QOJ3U',
                    icon: <YouTubeIcon />,
                },
                {
                    label: 'Amazon Music',
                    href: 'https://music.amazon.ca/albums/B0H7MLNW5S',
                    icon: <AmazonMusicIcon />,
                },
            ],
        },
    ];
    const { t } = useTranslation();
    return (
        <Container className='container'>
            <Box className='bitoBg'>
            </Box>
            <Box className='floatit'>
                <p className='contentW personalContent'>
                    <h3> Rim "Bam" Bito <Link className='linkPop' to='../about-people-arena'><PfIcon /></Link></h3>
                    <br />
                    <a href='https://www.facebook.com/lucastle69' rel="noreferrer" target='_blank' className='noDeco'>
                        <FacebookIcon />    Facebook
                    </a>
                    <br />
                    <a href='https://www.instagram.com/lionesus/' rel="noreferrer" target='_blank' className='noDeco'>
                        <InstagramIcon />   Instagram
                    </a>
                    <br />
                    <a href='https://www.youtube.com/@lucastle69' rel="noreferrer" target='_blank' className='noDeco'>
                        <YouTubeIcon />    YouTube
                    </a>
                    <br />
                    <a href='https://pomoroad.com/' rel="noreferrer" target='_blank' className='noDeco'>
                        <PublicIcon />      Website
                    </a>
                    <br />
                </p>
            </Box>
            {releases.map((release) => (
                <Box key={release.title} id={release.id} className='banner'>
                    <h1 className='musicPageTitle'>{release.title}</h1>
                    <Typography className='musicAvailableNote'>{release.subtitle}</Typography>

                    <Box className='bannerMusic'>
                        <img
                            className='albumCover'
                            src={release.coverUrl}
                            alt={release.coverAlt}
                        />
                    </Box>

                    <Box className='streamButtons'>
                        {release.links.map(({ label, href, icon }) => (
                            <Button
                                key={label}
                                className='streamMusicButton'
                                href={href}
                                target='_blank'
                                rel='noreferrer'
                                variant='contained'
                                startIcon={icon}
                            >
                                {label}
                            </Button>
                        ))}
                    </Box>

                    <Typography className='musicAvailableNote'>
                        {t('music.also_available_on_favorite_service')}
                    </Typography>
                </Box>
            ))}


        </Container>
    )
}

export default CarloHome;
